import type { ReactNode } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Badge } from '@/shared/components/ui/badge';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components/ui/popover';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import { cn } from '@/core/lib/utils';

interface FiltersPopoverRootProps {
  children: ReactNode;
  activeCount?: number;
  label: string;
  className?: string;
  'data-testid'?: string;
}

function FiltersPopoverRoot({
  children,
  activeCount = 0,
  label,
  className,
  'data-testid': testId,
}: FiltersPopoverRootProps) {
  return (
    <Tooltip>
      <Popover>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              size="icon"
              variant="outline"
              className={cn('relative', className)}
              data-testid={testId}
            >
              <SlidersHorizontal className="h-4 w-4" />
              {activeCount > 0 && (
                <Badge className="absolute -top-1.5 -right-1.5 h-4 min-w-4 px-1 text-[.625rem] leading-none">
                  {activeCount}
                </Badge>
              )}
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        {children}
      </Popover>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}

interface FiltersPopoverContentProps {
  children: ReactNode;
  className?: string;
}

function FiltersPopoverContent({ children, className }: FiltersPopoverContentProps) {
  return (
    <PopoverContent align="end" className={cn('w-80 flex flex-col gap-4', className)}>
      {children}
    </PopoverContent>
  );
}

FiltersPopoverRoot.Content = FiltersPopoverContent;

export const FiltersPopover = FiltersPopoverRoot;
